<span translate="Settings.AccountSecuritySection.DeviceAuthentication"></span>

<div class="w-auto row row-cols-12">
    <ul class="list-group p-2 m-1">
        <li class="list-group-item subheader d-block">
            <div class="row w-100 d-flex align-items-center">
                <div class="col-6 firstcol"><span translate="Settings.AccountSecuritySection.Device"></span>
                </div>
                <div class="col-5"><span translate="Settings.AccountSecuritySection.DateAdded"></span>
                </div>
                <div class="col-1"></div>
            </div>
        </li>
        <li *ngFor="let device of devices; let i = index" class="list-group-item d-block">
            <app-settingsAccountSecurityWebauthnListitem [device]="device" (removeDevice)="removeDevice(i);"></app-settingsAccountSecurityWebauthnListitem>
        </li>
    </ul>
</div>